import { render } from "./Forge.vue?vue&type=template&id=495b0523"
import script from "./Forge.vue?vue&type=script&lang=js"
export * from "./Forge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Forge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "495b0523"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('495b0523', __exports__)) {
    api.reload('495b0523', __exports__)
  }
  
  module.hot.accept("./Forge.vue?vue&type=template&id=495b0523", () => {
    api.rerender('495b0523', render)
  })

}


export default __exports__